export function getAmountDescription(amount: string | undefined) {
  if (!amount) {
    return "1 numer";
  }

  if (amount === "2" || amount === "3" || amount === "4") {
    return `${amount} numery`;
  }

  if (amount === "5") {
    return `${amount} numerów`;
  }

  return "1 numer";
}
